import React, {Fragment} from 'react';

const Loading = props => {

    const {loading, className} = props;

    return (
        <Fragment>
            {loading &&
            <div className={`general-loading ${className}`}>
                <div className="spinner"/>
            </div>}
        </Fragment>
    );
};

export default Loading;
